export function isAxiosUnauthorizedError(error) {
  if (error.name !== 'AxiosError') {
    return false;
  }
  if (!error.response) {
    return false;
  }
  return error.response.status === 401;
}
